@if(loader){
<app-loader></app-loader>
}

<p-card header="Create Customer">

    <form [formGroup]="customerDetailsForm">
        <div class="formgrid grid">
            <div class="field col-12 flex justify-content-between align-items-center">
                <div class="flex">
                    <div class="flex align-items-start" style="margin-bottom: 15px;">
                        <div>
                            <p-button label="Save" class="p-button-outlined ml-2" icon=" pi pi-save" size="small"
                                (click)="createCustomer(customerDetailsForm.value)"></p-button>
                        </div>
                        <div>
                            <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                                size="small" (click)="cancel()"></p-button>

                        </div>
                    </div>
                </div>
                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            </div>


            &nbsp;
            <div class="field col-12 flex">
                <div class="flex align-items-center">
                    <p-radioButton value="individual" inputId="customertype_ii" formControlName="type"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.type.errors }"></p-radioButton>
                    <label for="customertype_ii" class="ml-2">Individual</label>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-radioButton value="company" inputId="customertype_cc" formControlName="type"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.type.errors }"></p-radioButton>
                    <label for="customertype_cc" class="ml-2">Company</label>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-checkbox label="Active" formControlName="isActive" [binary]="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.isActive.errors?.['requiredTrue'] }"></p-checkbox>
                    <small *ngIf="submitted && formControls.isActive.errors?.['requiredTrue']"
                        class="text-red-500">Required field.</small>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-checkbox label="Ship To Customer" formControlName="IsShipToCustomer" [binary]="true"
                        value="true"></p-checkbox>
                </div>
            </div>
        </div>

        <div class="mainframe" style="display: flex; gap: 20px;">

            <!-- LEFT SIDE (FORM - 70%) -->
            <div class="mainView-primary" style="width: 70%; display: flex; flex-direction: column; gap: 15px;">

                <!-- ROW 1 -->
                <div style="display: flex; gap: 15px;">

                    <!-- Customer Code -->
                    <div class="field w-full form-field">
                        <label class="label-required">Customer Code</label>

                        <div style="display:flex; gap:10px; align-items:center;">
                            <input type="text" pInputText placeholder="e.g C89098" formControlName="customerCode"
                                class="w-full p-inputtext-sm"
                                [readonly]="isEditMode || customer.length > 0 || !customerDetailsForm.controls.manualEntry.value"
                                (blur)="checkVendorCode()" (keydown)="onKeydown($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.customerCode.errors}" />

                            <p-checkbox formControlName="manualEntry" *ngIf="customer.length == 0"
                                (onChange)="manualEntry()" [binary]="true" label="Manual Entry">
                            </p-checkbox>
                        </div>
                    </div>

                    <!-- GST Treatment -->
                    <div class="field w-full form-field">
                        <label class="label-required">GST Treatment</label>
                        <div>
                            <p-dropdown formControlName="gstTreatment" [options]="gstTreatmentList" optionLabel="name"
                                placeholder="Select GST Treatment" class="w-full" [ngClass]="{
                                    'ng-invalid ng-dirty':
                                    submitted && formControls.gstTreatment.errors
                                }">

                                <ng-template let-item pTemplate="item">
                                    {{item.code}} - {{item.name}}
                                </ng-template>

                                <ng-template let-item pTemplate="selectedItem">
                                    {{item?.code}} - {{item?.name}}
                                </ng-template>

                            </p-dropdown>
                        </div>
                    </div>


                </div>

                <!-- ROW 2 -->
                <div style="display: flex; gap: 15px;">

                    <!-- Customer Name -->
                    <div class="field w-full form-field">
                        <label class="label-required">Customer Name</label>
                        <input pInputText placeholder="e.g XYZ" formControlName="customerName"
                            class="w-full p-inputtext-sm" (keydown)="onKeydown($event)"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.customerName.errors}" />
                    </div>

                    <!-- Customer Description -->
                    <div class="field w-full form-field">
                        <label>Customer Description</label>
                        <input pInputText placeholder="e.g ABC" formControlName="customerDescription"
                            class="w-full p-inputtext-sm" (keydown)="onKeydown($event)" />
                    </div>

                </div>

            </div>

            <!-- RIGHT SIDE (IMAGE - 30%) -->
            <div class="mainView-secondary"
                style="width: 30%; display:flex; flex-direction: column; align-items:center;">

                <input type="file" (change)="onFileSelected($event)" #fileInput hidden />

                <!-- Image Preview -->
                <div (click)="fileInput.click()" style="cursor:pointer;">
                    <img *ngIf="previewImage" [src]="previewImage" width="150" height="140"
                        style="border:2px solid #ccc; border-radius:10px; object-fit:cover;" />

                    <img *ngIf="!previewImage" src="./assets/upload-logo.jpg" width="120"
                        style="border:2px solid #ccc; border-radius:10px;" />
                </div>

                <!-- Delete -->
                <p-button *ngIf="previewImage" icon="pi pi-trash" severity="danger" class="mt-2"
                    (click)="deleteImage()">
                </p-button>

            </div>

        </div>


        <div>
            <div class="formgrid grid">
                <!-- <div class="field col-12 ">
            <input pInputText placeholder="Name" class="w-full p-inputtext-sm" formControlName="name"   [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.name.errors }"/>
            <small *ngIf="submitted && formControls.name.errors" id="name-error" class="text-red-500">Required field.</small>
        </div> -->
            </div>
            <p-tabView>
                <p-tabPanel header="General Information">
                    <!-- <div class="formgrid grid"> -->
                    <div class="grid ">
                        <div class="col">
                            <div class="field text-left" formGroupName="address">
                                <label for="address" class="label-required display">Address</label>
                                <input pInputText placeholder="Street Address" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm" formControlName="addressLine1"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.addressLine1.errors}" />
                                <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                                    id="name-error" class="text-red-500">Required field.</small>
                                <input pInputText placeholder="Street Address 2" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm mt-1" formControlName="addressLine2" />

                                <div class="flex mt-1">
                                    <div>
                                        <input pInputText placeholder="City" (keydown)="onKeydown($event)"
                                            class="w-full p-inputtext-sm" formControlName="city"
                                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors }" />
                                        <small *ngIf="submitted && formControls.address.controls.city.errors"
                                            id="name-error" class="text-red-500">Required field.</small>
                                    </div>

                                    <!--div class=" ml-1">
                                        
                                        <p-autoComplete [dropdown]="true" placeholder="State" [forceSelection]="true"
                                            [readonly]="true" (onBlur)="checkState()" (onSelect)="setState($event)"
                                            formControlName="state" [suggestions]="filterStates"
                                            (completeMethod)="filterState($event)" field="stateName"
                                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"
                                            (keydown.enter)="focusNextInput($event)"></p-autoComplete>
                                        <small *ngIf="submitted && formControls.address.controls.state.errors"
                                            id="name-error" class="text-red-500">Required field.</small>
                                    </div-->

       <div class=" ml-1">
                                        
                                        <p-autoComplete [dropdown]="true" placeholder="State" [forceSelection]="true"
                                            [readonly]="true" (onBlur)="checkState()" (onSelect)="setState($event)"
                                            formControlName="state" [suggestions]="filterStates"
                                            (completeMethod)="filterState($event)" field="stateName"
                                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"
                                            (keydown.enter)="focusNextInput($event)">
                                            <ng-template let-state pTemplate="item">
                                               {{ state.stateCode  }} - {{ state.stateName }}
                                            </ng-template>
                                        </p-autoComplete>
                                        <small *ngIf="submitted && formControls.address.controls.state.errors"
                                            id="name-error" class="text-red-500">Required field.</small>
                                    </div>

                                    <div class=" ml-1">
                                        <input pInputText placeholder="Zip" (keydown)="onKeydown($event)"
                                            class="w-full p-inputtext-sm" formControlName="zip"
                                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors }" />
                                        <small *ngIf="submitted && formControls.address.controls.zip.errors"
                                            id="name-error" class="text-red-500">Required field.</small>
                                        <small
                                            *ngIf="formControls.address.controls.zip.value && formControls.address.controls.zip.value.length !== 6"
                                            id="zip-invalid-error" class="text-red-500">Zip code must be exactly 6
                                            digits.</small>

                                    </div>

                                </div>
                                <input pInputText placeholder="Country" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm mt-1" formControlName="country"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}" />
                                <small *ngIf="submitted && formControls.address.controls.country.errors" id="name-error"
                                    class="text-red-500">Required field.</small>
                            </div>
                            <!-- <div class="field text-left">
                <label for="phone">Tax ID</label>
                <input pInputText placeholder="Tax ID" class="w-full p-inputtext-sm" formControlName="taxid"/>
            </div> -->
                            <div class="field text-left">
                                <label for="tags">GSTIN</label>
                                <!-- <input pInputText placeholder="GSTIN" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm" formControlName="GSTIN"
                                    [disabled]="customerDetailsForm.get('GSTIN')?.disabled ?? false" />
                                <small class="text-red-500"
                                    *ngIf="customerDetailsForm.get('GSTIN')?.invalid && customerDetailsForm.get('GSTIN')?.touched">
                                    Valid GSTIN is required
                                </small> -->
                                <input pInputText placeholder="GSTIN" formControlName="GSTIN"
                                    class="w-full p-inputtext-sm" />

                                <small
                                    *ngIf="customerDetailsForm.get('GSTIN')?.touched && customerDetailsForm.get('GSTIN')?.invalid">

                                    <span class="text-red-500"
                                        *ngIf="customerDetailsForm.get('GSTIN')?.errors?.['required']">
                                        GSTIN is required
                                    </span>

                                    <span class="text-red-500"
                                        *ngIf="customerDetailsForm.get('GSTIN')?.errors?.['pattern']">
                                        Invalid GSTIN format
                                    </span>

                                </small>

                            </div>

                        </div>
                        <div class="col ">
                            <div class="field text-left ">
                                <label for="phone">Phone</label>
                                <input min="0" pInputText placeholder="phone" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm" formControlName="phone" (input)="validater()"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.phone.errors }" />
                                <small *ngIf="submitted && formControls.phone.errors" id="name-error"
                                    class="text-red-500">Invalid phone number </small>
                                <small *ngIf="submitted && formControls.phone.hasError('pattern')" id="name-error"
                                    class="text-red-500"> Please enter a 10-digit phone number </small>
                                <small *ngIf="submitted && formControls.phone.hasError('maxlength')" id="name-error"
                                    class="text-red-500">phone number should not exceed more than 10 </small>
                            </div>
                            <div class="field text-left">
                                <label for="mobile">Mobile</label>
                                <input pInputText placeholder="mobile" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm" formControlName="mobile" (input)="validater()"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors }" />
                                <!-- <small *ngIf="submitted && formControls.mobile.errors?.['required']" id="name-error" class="text-red-500">Required field.</small> -->
                                <small *ngIf="submitted && formControls.mobile.errors?.['pattern']" id="name-error"
                                    class="text-red-500">Invalid mobile number. Please enter 10-digit mobile
                                    number.</small>
                            </div>
                            <div class="field text-left">
                                <label for="email">Email</label>
                                <input pInputText placeholder="Email" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm" formControlName="email"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors }" />
                                <!-- <small *ngIf="submitted && formControls.email.errors?.['required']" id="name-error" class="text-red-500">Required field.</small> -->
                                <small *ngIf="submitted && formControls.email.errors?.['email']" id="name-error"
                                    class="text-red-500">Invalid email address. Example: xyz&commat;gmail.com.</small>

                            </div>
                            <div class="field text-left">
                                <label for="website">Website</label>
                                <input pInputText placeholder="Website" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm" formControlName="website" />
                            </div>
                            <div class="field text-left">
                                <label for="tags">Tags</label>
                                <input pInputText placeholder="Tags" (keydown)="onKeydown($event)"
                                    class="w-full p-inputtext-sm" formControlName="tags" />
                            </div>

                        </div>
                    </div>
                    <!-- </div> -->
                </p-tabPanel>
                <p-tabPanel header="Contact & Addresses" *ngIf="isEditMode">
                    <div class="">
                        <div class="flex mb-1">
                            <p-button label="Add" icon="pi pi-user-plus" class="p-button-outlined" size="small"
                                (click)="showContact(customerId)"></p-button>
                            <p-button *ngIf="selectedContact && selectedContact.length > 0" label="Edit" class="ml-2"
                                icon="pi pi-user-edit" (click)="EditContact()" size="small"
                                severity="secondary"></p-button>
                            <p-button *ngIf="selectedContact && selectedContact.length > 0" label="Delete" class="ml-2"
                                icon="pi pi-trash" (click)="deleteContacts()" size="small" severity="danger"></p-button>
                        </div>
                        <p-table #dt1 [value]="ContactData" styleClass="p-datatable-striped"
                            [tableStyle]="{'min-width': '50rem'}" [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [rowsPerPageOptions]="[5, 10]" [globalFilterFields]="['name', 'address.city', 'email']"
                            [(selection)]="selectedContact">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th>
                                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th>Name</th>
                                    <th>Mobile</th>
                                    <th>Email</th>
                                    <th>City</th>
                                    <th>Country</th>
                                    <th>Address Type</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-customer>
                                <tr>
                                    <td>
                                        <p-tableCheckbox [value]="customer"></p-tableCheckbox>
                                    </td>
                                    <td>{{customer.contactName}}</td>
                                    <td>{{customer.mobile}}</td>
                                    <td>{{customer.email}}</td>
                                    <td>{{customer.address?.city}}</td>
                                    <td>{{customer.address?.country}}</td>
                                    <td>{{customer.type}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="8">No Records found.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabPanel>

                <p-tabPanel header="Account Receivables">
                    <div class="grid">
                        <div class="flex gap-4" style="width: 100%; flex-wrap: wrap;">
                            <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                                <div class="field text-left">
                                    <label for="termsCode">Payment Terms</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText class="w-full p-inputtext-sm" readonly
                                            (click)="getTermsCode()" formControlName="termsDescription"
                                            (keydown.enter)="focusNextInput($event)" />
                                        <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                            (click)="getTermsCode()"></button>
                                    </div>
                                    <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                                        <div class="field text-left">
                                            <label for="outstandingRec">Outstanding Receivables</label>
                                            <input pInputText class="w-full p-inputtext-sm"
                                                formControlName="outstandingRec"
                                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.outstandingRec.errors}" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                                <div class="field text-left">
                                    <label for="glAccountCode">GL Account</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText class="w-full p-inputtext-sm" formControlName="glAccountCode"
                                            (keydown.enter)="focusNextInput($event)" />
                                        <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                            (click)="getGLAccount()"></button>
                                    </div>

                                    <div class="field text-left flex items-center mt-5">
                                        <label for="noCreditCheck" class="mr-5">No Credit Check</label>
                                        <div class="p-checkbox">
                                            <p-checkbox formControlName="noCreditCheck" [binary]="true"></p-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                                <div class="field text-left">
                                    <label for="creditLimit">Credit Limit</label>
                                    <input pInputText class="w-full p-inputtext-sm" formControlName="creditLimit"
                                        [readonly]="formControls.noCreditLimit.value"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.creditLimit.errors}" />
                                </div>
                            </div>

                            <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                                <div class="field text-left flex items-center mt-5">
                                    <label for="noCreditLimit" class="mr-5">No Credit Limit</label>
                                    <div class="p-checkbox">
                                        <p-checkbox formControlName="noCreditLimit" [binary]="true"
                                            (onChange)="onNoCreditLimitChange()"></p-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>

            </p-tabView>

            <p-toast></p-toast>
        </div>

    </form>
</p-card>